'use strict';
import CookieUtils from 'helpers/cookie-utils'

function getBasketCookieString() {
  let basketCookie = CookieUtils.get('cached_basket') || '';
  return basketCookie;
}

export default {
  get totalItemCount() {
    let parts = getBasketCookieString().split('totalNumberOfItems=');
    let totalItemCount = parts[parts.length - 1];
    return totalItemCount;

  },
  containsProduct(productId) {
    return (getBasketCookieString().indexOf('|' + productId + '|') > -1);
  },
  isEmptyBasket: function() {
    let parts = getBasketCookieString().split('totalNumberOfItems=');
    let totalItemCount = parts[parts.length - 1];
    return (totalItemCount === ""
      || totalItemCount === undefined
      || totalItemCount === null
      || totalItemCount == "0"
      || totalItemCount == 0);
  }
}
